module.exports = __webpack_public_path__ + "routes/services/waiting-wheel-300x300.gif?1fce61e9";


//////////////////
// WEBPACK FOOTER
// ./routes/services/waiting-wheel-300x300.gif
// module id = 1350
// module chunks = 0